"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @next/next/no-sync-scripts */
var React = __importStar(require("react"));
var script_1 = require("./script");
require("./types");
var appHandlers = [
    "keyboardStateChanged",
    "onScreenVisibility",
    "BUILD_IM_CART",
    "openDeeplink",
    "LOGIN_STATE_CHANGED",
    "allowNativeBottomBarExit",
    "handleHardwareBack",
    "SEARCH_QUERY_INPUT",
    "swipeBottomsheet",
    "HANDLE_IM_SEARCH_ACTIONS",
    "onHalfCardBackgroundTap",
    "UPDATE_SELECTED_ADDRESS",
];
// Static queue to store errors before NewRelic is initialized
var errorQueue = [];
var ErrorBoundaryClass = /** @class */ (function (_super) {
    __extends(ErrorBoundaryClass, _super);
    function ErrorBoundaryClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
        };
        // Store original handlers to restore on unmount
        _this.originalHandlers = {};
        _this.processErrorQueue = function () {
            var _a;
            var newrelic = window.newrelic;
            if (newrelic && errorQueue.length > 0) {
                while (errorQueue.length > 0) {
                    var queuedError = errorQueue.shift();
                    if (queuedError) {
                        newrelic.noticeError(queuedError.error, __assign({ componentStack: (_a = queuedError.errorInfo) === null || _a === void 0 ? void 0 : _a.componentStack }, _this.props.customAttributes));
                    }
                }
            }
        };
        _this.queueError = function (error, errorInfo) {
            errorQueue.push({ error: error, errorInfo: errorInfo });
        };
        _this.captureException = function (err) {
            // Defensive: error may be null/undefined due to cross-origin scripts or bad Promise rejections
            var errorObj;
            if (err instanceof ErrorEvent) {
                if (err.error instanceof Error) {
                    errorObj = err.error;
                }
                else {
                    // Handle null/undefined error and add context
                    var message = err.message ||
                        "Script error." +
                            (err.filename ? " at ".concat(err.filename, ":").concat(err.lineno, ":").concat(err.colno) : "");
                    errorObj = new Error(message);
                }
            }
            else {
                var error = err.reason;
                if (error instanceof Error) {
                    errorObj = error;
                }
                else if (error === null || error === undefined) {
                    errorObj = new Error("Promise rejected with null/undefined");
                }
                else {
                    errorObj = new Error(String(error));
                }
            }
            var newrelic = window.newrelic;
            if (newrelic) {
                newrelic.noticeError(errorObj, __assign({ stack: errorObj.stack }, _this.props.customAttributes));
            }
            else {
                _this.queueError(errorObj);
            }
            return false;
        };
        _this.captureDidCatchException = function (error, errorInfo) {
            var newrelic = window.newrelic;
            if (newrelic) {
                newrelic.noticeError(error, __assign(__assign({}, errorInfo), _this.props.customAttributes));
            }
            else {
                _this.queueError(error, errorInfo);
            }
            _this.props.onErrorCapture(error, errorInfo);
            _this.setState({ hasError: true });
        };
        return _this;
    }
    ErrorBoundaryClass.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener("unhandledrejection", this.captureException);
        window.addEventListener("error", this.captureException);
        // Store original handlers and replace them
        appHandlers
            .filter(function (handler) { var _a, _b; return ((_b = (_a = _this.props.excludeLists) === null || _a === void 0 ? void 0 : _a.indexOf(handler)) !== null && _b !== void 0 ? _b : -1) === -1; })
            .forEach(function (handler) {
            // Store original handler
            _this.originalHandlers[handler] = window[handler];
            // Replace with empty function
            window[handler] = function () { };
        });
    };
    ErrorBoundaryClass.prototype.componentDidUpdate = function () {
        // Process any queued errors when the browser agent becomes available
        this.processErrorQueue();
    };
    ErrorBoundaryClass.prototype.componentWillUnmount = function () {
        window.removeEventListener("unhandledrejection", this.captureException);
        window.removeEventListener("error", this.captureException);
        // Restore original handlers
        Object.entries(this.originalHandlers).forEach(function (_a) {
            var handler = _a[0], originalFn = _a[1];
            window[handler] = originalFn;
        });
    };
    ErrorBoundaryClass.prototype.componentDidCatch = function (error, errorInfo) {
        this.captureDidCatchException(error, errorInfo);
    };
    ErrorBoundaryClass.prototype.render = function () {
        if (this.state.hasError) {
            return React.createElement(React.Fragment, null, this.props.ErrorComponent());
        }
        return React.createElement(React.Fragment, null, this.props.children);
    };
    return ErrorBoundaryClass;
}(React.PureComponent));
// Wrapper functional component that uses the hook
var NewRelicErrorBoundary = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("script", { type: "text/javascript", src: "https://media-assets.swiggy.com/portal/static-assets/js/nr-mini-v1.js?v=10", crossOrigin: "anonymous" }),
        React.createElement("script", { type: "text/javascript" }, (0, script_1.finalScript)(props.applicationID)),
        React.createElement(ErrorBoundaryClass, __assign({}, props))));
};
exports.default = NewRelicErrorBoundary;
